import { render, staticRenderFns } from "./DeviceMonitor.vue?vue&type=template&id=e8f56afc&scoped=true"
import script from "./DeviceMonitor.vue?vue&type=script&lang=js"
export * from "./DeviceMonitor.vue?vue&type=script&lang=js"
import style0 from "./DeviceMonitor.vue?vue&type=style&index=0&id=e8f56afc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f56afc",
  null
  
)

export default component.exports